import * as React from 'react';
import { MessagePart, InfoBarCustomAction } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import InfoBarMessageWithCustomAction from './InfoBarMessageWithCustomAction';
import InfoBarMessageWithShowDetailsAction from './InfoBarMessageWithShowDetailsAction';
import InfoBarMessageWithCalloutAction from './InfoBarMessageWithCalloutAction';
import InfoBarMessageWithOptionsAction from './InfoBarMessageWithOptionsAction';
import InfoBarMessageInfoIcon from './InfoBarMessageInfoIcon';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import {
    isMessagePartCustomAction,
    isMessagePartShowDetailsAction,
    isMessagePartCalloutAction,
    isMessagePartOptionsAction,
    isMessagePartInfoIcon,
} from 'owa-info-bar/lib/utils/messagePartUtility';
import getInfoBarLinkColorStyle from 'owa-info-bar/lib/utils/getInfoBarLinkColorStyle';

const classNames = require('classnames');
let styles = require('./InfoBarMessage.scss');

export interface InfoBarMessagePartProps {
    messagePart: MessagePart;
    colorScheme?: ColorScheme;
    isMessageSemibold?: boolean;
}

const InfoBarMessagePart = (props: InfoBarMessagePartProps): JSX.Element => {
    const { messagePart, colorScheme, isMessageSemibold } = props;

    const isFloatRight = (messagePart as InfoBarCustomAction).floatRight === true ? true : false;
    const linkStyle = classNames(
        styles.link,
        getInfoBarLinkColorStyle(colorScheme),
        isFloatRight && styles.floatRight
    );

    if (isMessagePartCustomAction(messagePart)) {
        return <InfoBarMessageWithCustomAction customAction={messagePart} className={linkStyle} />;
    } else if (isMessagePartShowDetailsAction(messagePart)) {
        return <InfoBarMessageWithShowDetailsAction {...messagePart} className={linkStyle} />;
    } else if (isMessagePartCalloutAction(messagePart)) {
        return <InfoBarMessageWithCalloutAction {...messagePart} className={linkStyle} />;
    } else if (isMessagePartOptionsAction(messagePart)) {
        return <InfoBarMessageWithOptionsAction {...messagePart} className={linkStyle} />;
    } else if (isMessagePartInfoIcon(messagePart)) {
        return <InfoBarMessageInfoIcon toolTipMessage={messagePart.toolTipMessage} />;
    }

    return <span className={isMessageSemibold && styles.isSemibold}>{messagePart}</span>;
};

export default InfoBarMessagePart;
